/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:53
 */
import EpochColumn from './EpochColumn';

class DateTimeColumn extends EpochColumn {

  constructor(params) {
    params.format = 'd/m/Y H:i';
    params.selector = '.js-column-datetime';
    params.enableTime = true;
    super(params);
  }

}

export default DateTimeColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/DateTimeColumn.js